import { ListItem, ListItemText } from "@mui/material";
import * as React from "react";
import {
    AvatarStyled,
    ListItemAvatarContainer,
    ListItemButtonContainer,
    ListItemTextHeadline,
} from "./UserConversationList.styles";
import { ReactNode } from "react";
import { UserConversationsForPost } from "./UserConversation.types";
import { UserAvatarFactory } from "../../../UserAvatar/UserAvatarFactory";
import { AvatarOptions } from "../../../UserAvatar/UserAvatar.types";
import { avatarFallbackColorSelector } from "../../../../Shared/Avatar/AvatarFallbackColorSelector";
import { UsersIcon } from "@icons/UsersIcon";

export function UserConversation({
    conversation,
    onItemClick,
    secondaryAction,
}: {
    conversation: UserConversationsForPost;
    onItemClick: (key: string) => void;
    secondaryAction: ReactNode;
}) {
    const avatarOptions: AvatarOptions = {
        avatar: conversation.imageUrl,
        gender: undefined,
        uuid: conversation.key,
        fallbackIcon: <UsersIcon />,
        component: AvatarStyled,
        ...{
            sx: {
                color: avatarFallbackColorSelector(conversation.key),
                width: "32px",
                height: "32px",
                borderRadius: "50%",
            },
        },
    };

    return (
        <ListItemButtonContainer
            onClick={() => onItemClick(conversation.key)}
            disableRipple={true}
        >
            <ListItem secondaryAction={secondaryAction} disablePadding>
                <ListItemAvatarContainer>
                    {UserAvatarFactory(avatarOptions)}
                </ListItemAvatarContainer>
                <ListItemText>
                    <ListItemTextHeadline>
                        {conversation.name}
                    </ListItemTextHeadline>
                </ListItemText>
            </ListItem>
        </ListItemButtonContainer>
    );
}
